import { createContext, useContext } from 'react';

/** The company's support phone (public branding): who a blocked driver calls (screen 08). */
export const SupportPhoneContext = createContext<string | null>(null);
export const useSupportPhone = () => useContext(SupportPhoneContext);
